export const translations = {
  fr: {
    services: {
      title: "Mes 3 Services Essentiels",
      service1: {
        title: "Conception UX & Habillage UI Complet",
        description: "De l'idée au pixel parfait : je crée vos maquettes et prototypes en pensant d'abord à l'expérience utilisateur (app mobile, site web et SaaS).",
        features: [
          "Votre feuille de route visuelle complète pour développer sereinement avec un design qui capte et convertit."
        ]
      },
      service2: {
        title: "Prototypage Interactif Haute-Fidélité",
        description: "Transformez vos maquettes statiques en prototypes cliquables ultra-réalistes. Testez et validez comme si l'application existait déjà.",
        features: [
          "Parfait pour convaincre investisseurs, tester auprès d'utilisateurs, ou valider votre concept avant le développement."
        ]
      },
      service3: {
        title: "Application Complète No-Code & IA",
        description: "Développement rapide avec des outils no-code et intelligence artificielle : votre application fonctionnelle livrée en quelques semaines.",
        features: [
          "Budget divisé par 3 par rapport au développement classique. Performance et rapidité sans compromis sur la qualité."
        ]
      }
    },
    references: {
      title: "Mes Références",
      subtitle: "Découvrez une sélection d'interfaces mobiles que j'ai conçues, alliant esthétique moderne et expérience utilisateur optimale.",
      desktop: {
        title: "Designs Desktop & Web",
        subtitle: "Mes créations d'interfaces desktop et web en format panoramique"
      },
      impact: {
        phrase1: "L'UI/UX design : le pilier de votre réussite digitale",
        phrase2: "Designs sur mesure selon vos objectifs",
        phrase3: "Une interface bien conçue fidélise vos utilisateurs"
      }
    },
    beforeAfter: {
      title: "Avant / Après",
      description: "Découvrez la transformation de vos interfaces. De designs basiques à des expériences modernes et engageantes qui captivent vos utilisateurs.",
      before: "AVANT",
      after: "APRÈS"
    },
    about: {
      title: "Qui suis-je ?",
      intro: "Je suis <name>Wassim Mhadhbi</name> UI/UX Designer depuis 2014.",
      conviction: {
        title: "Ma conviction",
        text: "L'expérience utilisateur est aussi importante que l'esthétique.",
        description: "Je place systématiquement l'UX au cœur de chaque projet, car c'est elle qui détermine véritablement sa réussite."
      },
      fundamentals: {
        title: "Mes fondamentaux",
        item1: "Un **parcours utilisateur pensé et fluide**",
        item2: "Une **navigation intuitive**",
        item3: "Une **clarté sans compromis**",
        item4: "Une **dimension émotionnelle** qui fait la différence"
      },
      conclusion: {
        part1: "À cela, j'associe un **design moderne et haut de gamme**, toujours aligné avec les objectifs du projet.",
        part2: "Car l'excellence naît de cette alliance entre",
        functionality: "fonctionnalité",
        aesthetic: "esthétique"
      }
    },
    contact: {
      title: "Contact",
      subtitle: "Comment me contacter ?",
      optionLabel: "Option",
      option1: {
        title: "Via ComeUp",
        description: "Inscription gratuite et instantanée en quelques secondes sur la plateforme. Accès direct à mon profil, portfolio complet et système de messagerie intégré.",
        button: "Accéder à ComeUp"
      },
      option2: {
        title: "Contact Direct WhatsApp",
        description: "Pour un premier échange rapide et des questions spécifiques, contactez-moi directement via WhatsApp.",
        button: "Ouvrir WhatsApp"
      },
      guarantee: {
        title: "Réactivité garantie",
        item1: {
          title: "Réactivité",
          subtitle: "garantie"
        },
        item2: {
          title: "Réponse sous 2h",
          subtitle: "en journée"
        },
        item3: {
          title: "Brief détaillé sous 24h",
          subtitle: "maximum"
        }
      }
    },
    form: {
      intro: {
        title: "Démarrons votre projet",
        subtitle: "Quelques questions pour mieux comprendre vos besoins et vous proposer la meilleure solution."
      },
      progress: {
        step: "Étape"
      },
      success: {
        title: "Message envoyé ! 🎉",
        message: "Merci pour votre confiance. Je reviendrai vers vous très rapidement."
      },
      error: {
        message: "Une erreur est survenue lors de l'envoi. Veuillez réessayer."
      },
      buttons: {
        previous: "Précédent",
        next: "Suivant",
        submit: "Envoyer",
        sending: "Envoi en cours..."
      },
      step1: {
        title: "Parlez-nous de votre projet",
        placeholder: "Décrivez votre projet en quelques lignes...",
        description: "Plus vous serez précis, mieux nous pourrons vous conseiller"
      },
      step2: {
        title: "Quel type de service recherchez-vous ?",
        options: {
          design: {
            label: "Conception Wireframe & Design, Maquette (UX/UI)",
            description: "Design complet de votre interface"
          },
          animation: {
            label: "Animation Interactive d'une Maquette",
            description: "Donner vie à vos designs"
          },
          nocode: {
            label: "Création d'Application Mobile No-Code",
            description: "Application fonctionnelle sans code"
          }
        }
      },
      step3: {
        title: "Quel est votre délai souhaité ?",
        options: {
          urgent: {
            label: "Urgent (1-2 semaines)",
            description: "Livraison express"
          },
          normal: {
            label: "Standard (3-4 semaines)",
            description: "Délai optimal"
          },
          flexible: {
            label: "Flexible (1-2 mois)",
            description: "Pas de rush"
          },
          discuss: {
            label: "À discuter",
            description: "Selon disponibilités"
          }
        }
      },
      step4: {
        title: "Quel est votre budget approximatif ?",
        options: {
          small: {
            label: "Moins de 1000€",
            description: "Petit projet"
          },
          medium: {
            label: "1000€ - 3000€",
            description: "Projet standard"
          },
          large: {
            label: "Plus de 3000€",
            description: "Projet premium"
          }
        }
      },
      step5: {
        title: "Comment pouvons-nous vous contacter ?",
        fields: {
          name: "Votre nom complet",
          email: "Votre email",
          phone: "Votre téléphone"
        }
      }
    },
    collaboration: {
      title: "Collaboration",
      subtitle: "Je propose à mes clients de collaborer via ComeUp, une plateforme française qui garantit la sécurité des paiements et la protection de vos projets.",
      whyTitle: "Pourquoi ComeUp ?",
      benefits: {
        benefit1: {
          title: "Paiements sécurisés",
          description: "Transactions protégées avec blocage des fonds jusqu'à validation du projet"
        },
        benefit2: {
          title: "Protection des deux parties",
          description: "Service de médiation en cas de désaccord pour une résolution équitable"
        },
        benefit3: {
          title: "Support dédié",
          description: "Équipe disponible 7j/7 pour accompagner vos projets"
        },
        benefit4: {
          title: "Évaluation transparente",
          description: "Système d'avis vérifié pour garantir la qualité des prestations"
        }
      },
      platform: {
        description: "Depuis <span class=\"text-[#DC1A5F] font-semibold\">2019</span>, je collabore via ComeUp, <span class=\"text-white font-medium\">leader français du freelancing</span>.",
        reviewsLink: "Voir les avis clients",
        trustpilot: "sur Trustpilot",
        advantages: {
          tracking: "Suivi en temps réel sur Figma",
          interaction: "Possibilité d'interagir directement sur Figma",
          voice: "Échanges vocaux possibles"
        }
      },
      alternativeNote: "💡 D'autres modalités de collaboration sont possibles — <span class=\"text-white font-medium\">discutons-en ensemble</span>",
      stats: {
        stat1: {
          text: "années d'expérience"
        },
        stat2: {
          text: "projets réalisés"
        },
        stat3: {
          text: "moyenne des avis"
        }
      },
      testimonials: {
        title: "Avis clients",
        link: "Voir mon profil ComeUp",
        reviews: {
          review1: "Prestataire de très haute qualité, grande attention au détail, très à l'écoute du client et travail soigneux ; vous pouvez lui faire confiance. Je reviendrai vers vous pour d'autres missions. Merci pour tout =)",
          review2: "Super boulot",
          review3: "Quel plaisir de travailler avec lui! Incroyable !!!",
          review4: "Très beau travail et en plus de ca le suivi est la. Merci",
          review5: "Bon rapport qualité prix",
          review6: "Top",
          review7: "Service au top, conforme et très réactif",
          review8: "Vraiment très souple très compréhensif ! Résultat très satisfaisant ! Merci encore !",
          review9: "Je suis très content du travail fourni ! Il est vraiment à l'écoute et d'une grande disponibilité malgré les plusieurs sollicitations. Travail de qualité. Je recommande ++",
          review10: "Top , réactif et professionnel",
          review11: "Très bon !",
          review12: "Très pro et à l'écoute des recommandations. Franchement une collaboration hyper agréable. Bonne continuation. je vous recommande vivement.",
          review13: "Travail bien fait.Merci",
          review14: "a l ecoute bon travail merci"
        }
      }
    }
  },
  eng: {
    services: {
      title: "My 3 Essential Services",
      service1: {
        title: "Complete UX Design & UI Styling",
        description: "From idea to perfect pixel: I create your mockups and prototypes with user experience as the top priority (mobile app, website and SaaS).",
        features: [
          "Your complete visual roadmap to develop confidently with a design that captures and converts."
        ]
      },
      service2: {
        title: "High-Fidelity Interactive Prototyping",
        description: "Transform your static mockups into ultra-realistic clickable prototypes. Test and validate as if the application already existed.",
        features: [
          "Perfect for convincing investors, testing with users, or validating your concept before development."
        ]
      },
      service3: {
        title: "Complete No-Code & AI Application",
        description: "Fast development with no-code tools and artificial intelligence: your functional application delivered in a few weeks.",
        features: [
          "Budget reduced by 3 compared to traditional development. Performance and speed without compromising quality."
        ]
      }
    },
    references: {
      title: "My References",
      subtitle: "Discover a selection of mobile interfaces I've designed, combining modern aesthetics with optimal user experience.",
      desktop: {
        title: "Desktop & Web Designs",
        subtitle: "My desktop and web interface creations in panoramic format"
      },
      impact: {
        phrase1: "UI/UX design: the pillar of your digital success",
        phrase2: "Tailor-made designs according to your goals",
        phrase3: "A well-designed interface retains your users"
      }
    },
    beforeAfter: {
      title: "Before / After",
      description: "Discover the transformation of your interfaces. From basic designs to modern and engaging experiences that captivate your users.",
      before: "BEFORE",
      after: "AFTER"
    },
    about: {
      title: "Who am I?",
      intro: "I am <name>Wassim Mhadhbi</name> UI/UX Designer since 2014.",
      conviction: {
        title: "My conviction",
        text: "User experience is as important as aesthetics.",
        description: "I systematically place UX at the heart of every project, as it truly determines its success."
      },
      fundamentals: {
        title: "My fundamentals",
        item1: "A **thoughtful and fluid user journey**",
        item2: "An **intuitive navigation**",
        item3: "**Uncompromising clarity**",
        item4: "An **emotional dimension** that makes the difference"
      },
      conclusion: {
        part1: "To this, I add a **modern and high-end design**, always aligned with the project objectives.",
        part2: "Because excellence is born from this alliance between",
        functionality: "functionality",
        aesthetic: "aesthetic"
      }
    },
    contact: {
      title: "Contact",
      subtitle: "How to contact me?",
      optionLabel: "Option",
      option1: {
        title: "Via ComeUp",
        description: "Free and instant registration in a few seconds on the platform. Direct access to my profile, complete portfolio and integrated messaging system.",
        button: "Access ComeUp"
      },
      option2: {
        title: "Direct WhatsApp Contact",
        description: "For a quick first exchange and specific questions, contact me directly via WhatsApp.",
        button: "Open WhatsApp"
      },
      guarantee: {
        title: "Guaranteed Reactivity",
        item1: {
          title: "Reactivity",
          subtitle: "guaranteed"
        },
        item2: {
          title: "Response within 2h",
          subtitle: "during the day"
        },
        item3: {
          title: "Detailed brief within 24h",
          subtitle: "maximum"
        }
      }
    },
    form: {
      intro: {
        title: "Let's start your project",
        subtitle: "A few questions to better understand your needs and offer you the best solution."
      },
      progress: {
        step: "Step"
      },
      success: {
        title: "Message sent! 🎉",
        message: "Thank you for your trust. I will get back to you very quickly."
      },
      error: {
        message: "An error occurred while sending. Please try again."
      },
      buttons: {
        previous: "Previous",
        next: "Next",
        submit: "Send",
        sending: "Sending..."
      },
      step1: {
        title: "Tell us about your project",
        placeholder: "Describe your project in a few lines...",
        description: "The more specific you are, the better we can advise you"
      },
      step2: {
        title: "What type of service are you looking for?",
        options: {
          design: {
            label: "Wireframe & Design Conception, Mockup (UX/UI)",
            description: "Complete design of your interface"
          },
          animation: {
            label: "Interactive Mockup Animation",
            description: "Bring your designs to life"
          },
          nocode: {
            label: "No-Code Mobile Application Creation",
            description: "Functional application without code"
          }
        }
      },
      step3: {
        title: "What is your desired deadline?",
        options: {
          urgent: {
            label: "Urgent (1-2 weeks)",
            description: "Express delivery"
          },
          normal: {
            label: "Standard (3-4 weeks)",
            description: "Optimal timeframe"
          },
          flexible: {
            label: "Flexible (1-2 months)",
            description: "No rush"
          },
          discuss: {
            label: "To discuss",
            description: "According to availability"
          }
        }
      },
      step4: {
        title: "What is your approximate budget?",
        options: {
          small: {
            label: "Less than €1000",
            description: "Small project"
          },
          medium: {
            label: "€1000 - €3000",
            description: "Standard project"
          },
          large: {
            label: "More than €3000",
            description: "Premium project"
          }
        }
      },
      step5: {
        title: "How can we contact you?",
        fields: {
          name: "Your full name",
          email: "Your email",
          phone: "Your phone"
        }
      }
    },
    collaboration: {
      title: "Collaboration",
      subtitle: "I offer my clients the opportunity to collaborate through ComeUp, a French platform that ensures secure payments and project protection.",
      whyTitle: "Why ComeUp?",
      benefits: {
        benefit1: {
          title: "Secure Payments",
          description: "Protected transactions with funds held until project validation"
        },
        benefit2: {
          title: "Two-Party Protection",
          description: "Mediation service in case of disagreement for a fair resolution"
        },
        benefit3: {
          title: "Dedicated Support",
          description: "Team available 7/7 to support your projects"
        },
        benefit4: {
          title: "Transparent Evaluation",
          description: "Verified review system to guarantee service quality"
        }
      },
      platform: {
        description: "Since <span class=\"text-[#DC1A5F] font-semibold\">2019</span>, I collaborate via ComeUp, <span class=\"text-white font-medium\">French freelancing leader</span>.",
        reviewsLink: "See client reviews",
        trustpilot: "on Trustpilot",
        advantages: {
          tracking: "Real-time tracking on Figma",
          interaction: "Possibility to interact directly on Figma",
          voice: "Voice exchanges possible"
        }
      },
      alternativeNote: "💡 Other collaboration methods are possible — <span class=\"text-white font-medium\">let's discuss it together</span>",
      stats: {
        stat1: {
          text: "years of experience"
        },
        stat2: {
          text: "completed projects"
        },
        stat3: {
          text: "average rating"
        }
      },
      testimonials: {
        title: "Client Reviews",
        link: "View my ComeUp profile",
        reviews: {
          review1: "Very high quality service provider, great attention to detail, very attentive to the client and meticulous work; you can trust him. I will come back to you for other missions. Thank you for everything =)",
          review2: "Great job",
          review3: "What a pleasure to work with him! Incredible!!!",
          review4: "Very nice work and on top of that the follow-up is there. Thank you",
          review5: "Good value for money",
          review6: "Top",
          review7: "Top service, compliant and very responsive",
          review8: "Really very flexible, very understanding! Very satisfactory result! Thank you again!",
          review9: "I am very happy with the work provided! He is really attentive and highly available despite the multiple requests. Quality work. I highly recommend ++",
          review10: "Top, responsive and professional",
          review11: "Very good!",
          review12: "Very professional and attentive to recommendations. Honestly a very pleasant collaboration. Good luck. I highly recommend you.",
          review13: "Work well done. Thank you",
          review14: "attentive good work thank you"
        }
      }
    }
  }
};

export const getTranslation = (language, key) => {
  const keys = key.split('.');
  let value = translations[language];
  
  for (const k of keys) {
    if (value && typeof value === 'object') {
      value = value[k];
    } else {
      return key; // Retourne la clé si la traduction n'existe pas
    }
  }
  
  return value || key;
};
